import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
export function WhatWeDo() {
  const estheticServices = ['Scar Camouflage', 'Facial Camouflage', 'Birth Marks', 'Stretch Mark Microneedling', 'Stretch Mark Camouflage', 'Vitiligo Camouflage', 'Tattoo Laser Removal', 'Areola Restoration', 'More...'];
  const trainingServices = ['Scar Camouflage Master Certification', 'Hands-On Workshops', 'Online Modules', 'Advanced Techniques', 'Business Setup Guidance'];
  return <section id="what-we-do" className="py-24 lg:py-32 px-6 lg:px-12 max-w-[1400px] mx-auto" data-id="element-208">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="text-center mb-16" data-id="element-209">
        <h2 className="font-serif text-4xl lg:text-5xl font-light text-black mb-6" data-id="element-210">
          What We Do
        </h2>
        <div className="flex items-center justify-center gap-2" data-id="element-211">
          <span className="w-16 h-[1px] bg-taupe/50" data-id="element-212"></span>
          <div className="w-2 h-2 rotate-45 bg-taupe-dark" data-id="element-213"></div>
          <span className="w-16 h-[1px] bg-taupe/50" data-id="element-214"></span>
        </div>
      </motion.div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-215">
        {/* Esthetic Services Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="bg-white p-10 lg:p-16 shadow-sm border border-taupe/10 flex flex-col h-full" data-id="element-216">
          <h3 className="font-serif text-2xl lg:text-3xl mb-8 text-black tracking-wide" data-id="element-217">
            ESTHETIC SERVICES
          </h3>

          <ul className="flex flex-col gap-4 mb-12 flex-1" data-id="element-218">
            {estheticServices.map((service, idx) => <li key={idx} className="flex items-center gap-3 font-sans text-black/80" data-id="element-219">
                <ChevronRight size={14} className="text-taupe-dark flex-shrink-0" data-id="element-220" />
                <span data-id="element-221">{service}</span>
              </li>)}
          </ul>

          <a href="#" className="bg-black text-white px-8 py-4 text-xs uppercase tracking-widest font-sans hover:bg-black/80 transition-colors text-center w-full sm:w-auto self-start" data-id="element-222">
            Learn More
          </a>
        </motion.div>

        {/* Training Card */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-10 lg:p-16 shadow-sm border border-taupe/10 flex flex-col h-full" data-id="element-223">
          <h3 className="font-serif text-2xl lg:text-3xl mb-8 text-black tracking-wide" data-id="element-224">
            TRAINING
          </h3>

          <ul className="flex flex-col gap-4 mb-12 flex-1" data-id="element-225">
            {trainingServices.map((service, idx) => <li key={idx} className="flex items-center gap-3 font-sans text-black/80" data-id="element-226">
                <ChevronRight size={14} className="text-taupe-dark flex-shrink-0" data-id="element-227" />
                <span data-id="element-228">{service}</span>
              </li>)}
          </ul>

          <a href="#" className="bg-black text-white px-8 py-4 text-xs uppercase tracking-widest font-sans hover:bg-black/80 transition-colors text-center w-full sm:w-auto self-start" data-id="element-229">
            Learn More
          </a>
        </motion.div>
      </div>
    </section>;
}